import { cn } from '@/lib/utils';
import { ACCENT_MARK_CLASS } from '@/styles/accentMark';

interface NumberMarkProps {
  value: number;
  className?: string | undefined;
}

export function NumberMark({ value, className }: NumberMarkProps) {
  return (
    <span
      aria-hidden
      className={cn(
        'inline-flex size-6 shrink-0 items-center justify-center rounded-full text-xs font-semibold tabular-nums',
        ACCENT_MARK_CLASS,
        className,
      )}
    >
      {value}
    </span>
  );
}
